import { XIcon } from '@adornis/chemistry/elements/components/x-icon.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-icon
 */
@customElement('cr-icon')
export class ChromiumIcon extends XIcon {
  override connectedCallback(): void {
    super.connectedCallback();

    const type = this.getAttribute('outlined');
    if (!type) this.setAttribute('outlined', '');
  }
}
